import { createApp } from "vue";
import store from "./store/store";
import ParkMap from "./ParkMap.vue"
import { i18n } from '../../i18n';

if (document.querySelector('#park_map')) {
  const app = createApp(ParkMap)
  app.use(store);
  app.use(i18n);
  app.mount('#park_map');
}
